<template>
  <div class="card">
    <div ref="svg" v style="width: 100%; height: 210px; margin-bottom:10px" id="listeners"></div>
  </div>
</template>
<script>
import svgMap from "svgmap";
import "svgmap/dist/svgMap.min.css";

export default {
  props: {
    data: {
      type: Array,
    },
  },

  data() {
    return {
      stats: {
        data: {
          listeners: {
            name: "Listeners",
            thousandSeparator: ",",
          },
        },
        applyData: "listeners",

        values: {},
      },
      svgMap : null
    };
  },

  watch: {
 
    data:{
      immediate:true,
      handler(value){

      var result = _.cloneDeep(_.countBy(value, "iso_code"));

      Object.entries(result).forEach((element, i) => {
        result[element[0]] = { listeners: element[1] };
      });

      this.stats.values = result;

    if (this.svgMap == undefined) return
          this.svgMap.applyData(this.stats)
        }

    },
  },



    mounted() {

      this.svgMap = new svgMap({
        targetElementID: "listeners",
        data: this.stats,
        colorMin: "#9f7ce0",
        colorMax: "#6f42c1",
        noDataText: "0 listeners",
        flagType: "emoji",
      });

      //console.log(this.svgMap.emojiFlags);

    },
};
</script>